import styled from "styled-components";
import { StyledHomePageSectionBlock } from "../styledHomePage";
import { motion } from "framer-motion";

export const StyledHomePageCalculatorSection = styled(motion.div)`
  overflow: hidden;
  padding: 100px 0;
  
  @media screen and (max-width: 768px) {
    padding: 50px 0;
  }
`;
export const StyledHomePageCalculatorBlock = styled(StyledHomePageSectionBlock)`
  padding: 0 15px;
  position: relative;
  @media(min-width: 992px) {
    &:before {
      width: 100%;
      max-width: 495px;
      height: 495px;
      content: '';
      position: absolute;
      top: 383px;
      right: -229px;
      border-radius: 50%;
      background: rgba(23, 37, 160, 0.15);
      filter: blur(100px);
      user-select: none;
    }
  }

`;
export const StyledCalculatorContent = styled.div`
  padding: 100px 160px 70px 170px;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  background: #A4A8CD;
  box-shadow: 1px 1px 100px rgb(0 0 0 / 10%);
  border-radius: 15px;


  &:before {
    width: 100%;
    max-width: 370px;
    height: 370px;
    content: '';
    position: absolute;
    top: 60px;
    left: 0;
    border-radius: 50%;
    background: rgba(23, 37, 160, 0.3);
    filter: blur(125px);
  }

  &:after {
    width: 100%;
    max-width: 370px;
    height: 370px;
    content: '';
    position: absolute;
    top: 130px;
    right: 170px;
    border-radius: 50%;
    background: rgba(23, 37, 160, 0.3);
    filter: blur(125px);
  }

  .calculate-btn-response {
    display: none;
  }

  @media screen and (max-width: 992px) {
    padding: 35px 20px 45px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    &:before, &:after {
      content: none;
    }

    .calculate-btn-response {
      padding: 8px 27px;
      margin-top: 20px;
      display: block;
      order: 3;
    }
  }
`;

export const StyledRangeImage = styled.div`
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    margin-top: -5px;
    background: #D9D9D9;
    box-shadow: 1.81012px 1.81012px 4.52531px rgba(0, 0, 0, 0.25);
    border: 5px solid #FFFFFF;
    border-radius: 50%;
    cursor: pointer;
    opacity: 1;
    touch-action: pan-x;
    top: ${({ placeRange }) => `${placeRange.top}px`};
    left: ${({ placeRange }) => `${placeRange.left}px`};;
  }
`;

{/*Я не видалив оскільки не відомо до кінця як воно буде виглядати */}
export const StyledCalculateRangeDesktop = styled.div`
  .range-block {
    display: grid;
    grid-template-columns: repeat(4, 75px) 1fr;
    max-width: 330px;

    label {
      max-width: 62px;
    }
  }

  input {
    display: none;
  }
`;

export const StyledCalculatorContentRange = styled.div`
  width: 100%;
  max-width: 330px;
  min-width: 270px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;

  .total-range {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .total-badge {
      padding: 3px 33px;
      max-width: 200px;
      position: relative;
      border-radius: 35px;
      background: #1725A0;
      color: #FFFFFF;
      font-size: 31px;
      line-height: 30px;
      
      &:before {
        bottom: 2px;
      }
    }
  }

  @media (max-width: 768px) {
    order: 2;
  }

  @media (max-width: 576px) {
    .total-range {
      padding: 8px;
      margin-top: 30px;
      justify-content: space-around;
      background: rgba(23, 37, 160, 0.3);
      border-radius: 7px;

      span {
        font-size: 20px;
        font-weight: 700;
      }

      .total-badge {
        font-size: 20px;
      }
    }
  }

  //rc-slider

  .rc-slider {
    &-handle {
      width: 22px;
      height: 22px;
      background: #D9D9D9;
      box-shadow: 1.81012px 1.81012px 4.52531px rgba(0, 0, 0, 0.25) !important;
      border: 5px solid #FFFFFF;
      top: 2px;
      opacity: 1;

      &-dragging {
        border-color: #FFFFFF !important;
        box-shadow: none !important;
      }
    }

    &-rail {
      height: 2px;
      background: #FFFFFF;
    }

    &-track {
      background-color: #1725A0;
    }

    &-mark {
      display: block;
      top: -40px;
      font-size: 20px;

      &-text {
        color: #FFFFFF;

        &-active {
          &:before {
            content: '';
            position: absolute;
            background: rgba(23, 37, 160, 0.3);
            filter: blur(8.42182px);
            top: -2px;
            left: -10px;
            width: 37px;
            height: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    gap: 0;

    .about-range {
      span {
        font-size: 16px;
        font-weight: 700;
      }
    }

    .rc-slider {
      &-handle {
        width: 14px;
        height: 14px;
        top: 4px;
        border: 3px solid #FFFFFF;
      }

      &-rail {
        height: 4px;
      }

      &-track {
        background: inherit;
      }

      &-mark {
        font-size: 15px;

        &-text {
          &-active {
            &:before {
              width: 23px;
              height: 15px;
              top: 3px;
              left: -5px;
            }
          }
        }
      }
    }
  }
`;

export const StyledCalculateRange = styled(motion.div)`

  display: flex;
  flex-direction: column;
  justify-content: center;

  .about-range {
    padding-bottom: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 576px) {
    margin: 60px auto 0;
    width: 100%;
    .about-range {
      padding-bottom: 0;
      margin-top: 10px;
      order: 2;
    }

    .slider-range {
      order: 1;
    }
  }

`;

export const StyledRangeBadge = styled.div`
  padding: 0 35px 0 30px;
  max-width: 163px;
  position: relative;
  border-radius: 35px;
  background: #1725A0;
  color: #FFFFFF;
  font-size: 25px;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:before {
    content: "$";
    position: absolute;
    font-size: 18px;
    color: #FFFFFF;
    right: 10px;
    bottom: 0;
  }

  @media (max-width: 576px) {
    padding: 0 30px 0 17px;
    font-size: 16px;
    font-weight: 700;
  }
`;
export const StyledCalculatorContentInfo = styled(motion.div)`
  max-width: 370px;
  position: relative;
  z-index: 10;

  .calculate-btn {
    padding: 12px 42px;
  }

  .main-content {
    margin-top: 20px;
  }
  
  @media (min-width: 768px) {
    .main-content {
      margin-bottom: 40px;
    }
    
  }

  @media (max-width: 992px) {
    max-width: 100%;
  }
  @media (max-width: 768px) {
    order: 1;
    .calculate-btn {
      display: none;
    }
  }
  @media (max-width: 576px) {
    .main-title {
      font-size: 30px;
    }

    .main-content {
      margin-top: 10px;
      font-size: 14px;
    }
  }
`;